import React from "react";
import LogoAndSocial from "@/src/components/layout/footer/LogoAndSocial";
import AboutLinks from "@/src/components/layout/footer/AboutLinks";
import ContactInfo from "@/src/components/layout/footer/ContactInfo";
import PaymentGrid from "@/src/components/layout/footer/PaymentGrid";
import BottomLinks from "@/src/components/layout/footer/BottomLinks";

const FooterMain: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 relative overflow-hidden">
      {/* TRAVELA Watermark */}
      <div className="hidden absolute top-24 inset-0 lg:flex items-center justify-center pointer-events-none">
        <div className="text-ink-faint  text-mark-sm md:text-mark-md lg:text-mark-lg font-black tracking-widest select-none opacity-20 transform rotate-10 uppercase">
          travela
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 relative z-10">
        {/* Desktop */}
        <div className="hidden lg:flex lg:justify-start lg:items-start lg:gap-20">
          <div className="flex-shrink-0 w-80">
            <LogoAndSocial />
          </div>
          <div className="w-32">
            <AboutLinks />
          </div>
          <div className="w-64">
            <ContactInfo />
          </div>
          <div className="w-72">
            <PaymentGrid />
          </div>
        </div>

        {/* Tablet */}
        <div className="hidden md:block lg:hidden">
          <div className="flex justify-between items-start mb-8">
            <div className="flex-shrink-0 mr-8">
              <LogoAndSocial />
            </div>
            <div className="flex space-x-12">
              <AboutLinks />
              <ContactInfo />
            </div>
          </div>
          <div className="pt-8">
            <PaymentGrid />
          </div>
        </div>

        {/* Mobile */}
        <div className="block md:hidden">
          <div className="mb-8">
            <LogoAndSocial />
          </div>
          <div className="flex justify-between mb-8">
            <AboutLinks />
            <ContactInfo />
          </div>
          <div className="mb-8">
            <PaymentGrid />
          </div>
          <BottomLinks />
        </div>

        {/* Bottom Section for md+ */}
        <div className="hidden md:block pt-0 mt-12">
          <BottomLinks />
        </div>
      </div>
    </footer>
  );
};

export default FooterMain;
